import React from "react";

export const PdfGenerationContext = React.createContext(false);
